import React from 'react';
import styled from '../../styled';
import Theme from '../../themes/index';
const positionMap = {
    TOP: 0,
    RIGHT: 90,
    BOTTOM: 180,
    LEFT: 270,
};
export const StyledSvg = styled.svg `
  width: ${({ size, theme }) => theme.icons.size[size]};
  height: ${({ size, theme }) => theme.icons.size[size]};
  transform: rotate(${({ deg }) => deg || 0}deg);
  fill: ${({ color }) => color};
`;
export const iconGenerator = (Component) => ({ size, color = 'INK_600', position = 'TOP', }) => (React.createElement(Component, { size: size, color: Theme.colors[color], deg: positionMap[position] }));
//# sourceMappingURL=Icon.js.map